import css from './SearchTagBar.module.scss';
import { ITag } from '../../../../../../../../entities/module/private-template-module-tag/api/types';
import useCatchEnterClick from '../../../../../../../../hooks/useCatchEnterClick';
import SearchTagsInput
// eslint-disable-next-line max-len
	from '../../../../../../../../widgets/templates/private-template-tag-group-panel/ui/dropdown/search-bar/search-input/search-tags-input';
import { notificationError } from '../../../../../../../Notifications/callNotifcation';

interface SearchTagBarProps {
	search: string,
	tags: ITag[] | undefined,
	setSearch: (value: string) => void,
	createTag: (value: string) => Promise<void>,
}

export const SearchTagGroupsBar = ({
	tags,
	search,
	createTag,
	setSearch,
}: SearchTagBarProps) => {
	const handleSearch = (text: string) => {
		setSearch(text);
	};

	const onCreateTag = async () => {
		try {
			await createTag(search);

			setSearch('');
		} catch (e) {
			notificationError('Произошла ошибка при создании тега', 'Не удалось создать тег');
		}
	};

	useCatchEnterClick(onCreateTag, !!search && !tags?.length);

	return (
		<div className={css.dropdown_wrapper}>
			<SearchTagsInput
				placeholder="Поиск по тегам"
				searchValue={search}
				onChange={handleSearch}
			/>
		</div>
	);
};
